import { render, staticRenderFns } from "./bulkUpload.vue?vue&type=template&id=4efcebe1&scoped=true&"
import script from "./bulkUpload.vue?vue&type=script&lang=js&"
export * from "./bulkUpload.vue?vue&type=script&lang=js&"
import style0 from "./bulkUpload.vue?vue&type=style&index=0&id=4efcebe1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efcebe1",
  null
  
)

export default component.exports